import AxiosConfig from '../../../config/AxiosConfig';

const useGetMatchingInternalProducts = () => {
  const getMatchingProducts = async (searchIndex) => {
    try {
      const response = await AxiosConfig.create(
        'get',
        `/savdraft/matchingInternalProducts/${searchIndex}`
      )
        .call()
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to fetch matching products:', err);
      throw new Error(`Products fetch failed: ${err.message}`);
    }
  };

  return {
    getMatchingProducts,
  };
};

export default useGetMatchingInternalProducts;
